"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const SelectOption = ({ options, names, onChange, value }) => (React.createElement("div", { style: { display: "flex", flexDirection: "row", flexWrap: "wrap" } }, options.map((opt, i) => {
    const selected = opt === value;
    return (React.createElement("a", { key: i, style: selected
            ? {
                textDecoration: "none",
                fontWeight: "bold",
                backgroundColor: "#222",
                color: "white",
                marginLeft: 5,
                marginBottom: 5,
                padding: 5
            }
            : {
                textDecoration: "none",
                fontWeight: "bold",
                backgroundColor: "#aaa",
                color: "#222",
                marginLeft: 5,
                marginBottom: 5,
                padding: 5
            }, onClick: () => onChange(opt) }, names[i]));
})));
exports.StartOperationSelectOption = ({ value, onChange }) => (React.createElement(SelectOption, { value: value, onChange: onChange, options: ["root", "tetraRoot", "squareRoot"], names: ["Cube", "Tetrahedron", "Square"] }));
exports.OperationSelectOption = ({ value, onChange }) => (React.createElement(SelectOption, { value: value, onChange: onChange, options: [
        "pop",
        "pyramid",
        "truncatedPyramid",
        "bevel",
        "jump",
        "bigPop",
        "smallPop",
        "randomPop",
        "twist",
        "smallTwist",
        "randomTwist"
    ], names: [
        "Pop",
        "Pyramid",
        "Truncated Pyramid",
        "Bevel",
        "Jump",
        "Big Pop",
        "Small Pop",
        "Random Pop",
        "Twist",
        "Small Twist",
        "Random Twist"
    ] }));
exports.default = SelectOption;



// WEBPACK FOOTER //
// ./src/components/editor/SelectOption.tsx